import { billingInvoiceService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';

import {
  EXPORT_MONTH_BILLING_INVOICE,
  LOAD_BILLING_MONTHS,
  GET_PRICING_PLAN,
  GET_BILLING_PLAN,
  ADD_ACCOUNT_BALANCE,
  GET_CREDIT_CARDS,
  DELETE_CREDIT_CARD,
  ADD_CREDIT_CARD,
  VERIFY_CREDIT_CARD,
  UPDATE_CREDIT_CARD,
  UPDATE_BILLING_SETTINGS
} from './actionTypes';

import {
  SET_BILLING_MONTHS,
  SET_PRICING_PLAN,
  SET_BILLING_PLAN,
  SET_CREDIT_CARDS,
  SET_BILLING_SETTINGS
} from './mutationTypes';

const actions = {
  [EXPORT_MONTH_BILLING_INVOICE]({ dispatch }, request) {
    const exportName = `Monthly Billing - (${request.readableDt})`;
    request.exportName = exportName;

    dispatch('exportFiles/exportMonthBillingInvoice', request, { root: true });
  },

  async [LOAD_BILLING_MONTHS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: LOAD_BILLING_MONTHS });
    try {
      const response = await billingInvoiceService.getAvailableInvoicesByMonth(rootState.currentAccountId)

      commit(SET_BILLING_MONTHS, response.data);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: LOAD_BILLING_MONTHS });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: LOAD_BILLING_MONTHS, error: error });
    }
  },

  async [GET_PRICING_PLAN]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_PRICING_PLAN });
    try {
      const response = await billingInvoiceService.getPricingPlan(rootState.currentAccountId);

      commit(SET_PRICING_PLAN, response.data.pricingPlan);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_PRICING_PLAN });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_PRICING_PLAN, error: error });
    }
  },

  async [GET_BILLING_PLAN]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_BILLING_PLAN });
    try {
      const response = await billingInvoiceService.getBillingPlan(rootState.currentAccountId);

      commit(SET_BILLING_PLAN, response.data.billing);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_BILLING_PLAN });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_BILLING_PLAN, error: error });
    }
  },

  async [ADD_ACCOUNT_BALANCE]({ rootState, commit }, data) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: ADD_ACCOUNT_BALANCE });
    try {
      await billingInvoiceService.addAccountBalance(rootState.currentAccountId, data);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: ADD_ACCOUNT_BALANCE });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: ADD_ACCOUNT_BALANCE, error: error });
    }
  },

  async [UPDATE_BILLING_SETTINGS]({ rootState, commit }, data) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_BILLING_SETTINGS });
    try {
      const response = await billingInvoiceService.updateBillingSettings(rootState.currentAccountId, data);
      commit(SET_BILLING_SETTINGS, response.data.billingSettings);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_BILLING_SETTINGS });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_BILLING_SETTINGS, error: error });
    }
  },

  async [GET_CREDIT_CARDS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_CREDIT_CARDS });
    try {
      const response = await billingInvoiceService.getCreditCards(rootState.currentAccountId);

      commit(SET_CREDIT_CARDS, response.data.creditCards);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_CREDIT_CARDS });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_CREDIT_CARDS, error: error });
    }
  },
  async [DELETE_CREDIT_CARD]({ rootState, commit }, selectedCardToDelete) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_CREDIT_CARD });
    try {
      const response = await billingInvoiceService.deleteCreditCard(rootState.currentAccountId, selectedCardToDelete);

      commit(SET_CREDIT_CARDS, response.data.creditCards);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_CREDIT_CARD });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_CREDIT_CARD, error: error });
    }
  },
  async [ADD_CREDIT_CARD]({ rootState, commit }, creditCard) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: ADD_CREDIT_CARD });
    try {
      const response = await billingInvoiceService.addCreditCard(rootState.currentAccountId, creditCard);

      commit(SET_CREDIT_CARDS, response.data.creditCards);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: ADD_CREDIT_CARD });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: ADD_CREDIT_CARD, error: error });
    }
  },
  async [VERIFY_CREDIT_CARD]({ rootState, commit }, payload) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: VERIFY_CREDIT_CARD });
    try {
      await billingInvoiceService.verifyCreditCard(rootState.currentAccountId, payload.kyc, payload.creditCardId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: VERIFY_CREDIT_CARD });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: VERIFY_CREDIT_CARD, error: error });
    }
  },
  async [UPDATE_CREDIT_CARD]({ rootState, commit }, payload) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_CREDIT_CARD });
    try {
      const response = await billingInvoiceService.updateCreditCard(rootState.currentAccountId, payload.data, payload.creditCardId);
      
      commit(SET_CREDIT_CARDS, response.data.creditCards);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_CREDIT_CARD });
    }
    catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_CREDIT_CARD, error: error });
    }
  },
};

export default actions;